export const colorStatus = (status) => {
  switch (status) {
    case 1:
      // Aguardando NF
      return { color: "#290772" };
    case 2:
      // NF Enviada
      return { color: "#003F64" };
    case 3:
      // Faturado
      return { color: "#36694E" };
    case 4:
      // Conta errada
      return { color: "#64370C" };
    default:
      return { color: "#776400" };
  }
};

export const colorBgStatus = (status) => {
  switch (status) {
    case 1:
      // Aguardando NF
      return { background: "#D7E4FF" };
    case 2:
      // NF Enviada
      return { background: "#B6E3FD" };
    case 3:
      // Faturado
      return { background: "#C6F1DA" };
    case 4:
      // Conta errada
      return { background: "#FCDEC1" };
    default:
      return { background: "#FFD467" };
  }
};
